import { render, staticRenderFns } from "./BuscaGlobal.vue?vue&type=template&id=7e2236da&scoped=true"
import script from "./BuscaGlobal.vue?vue&type=script&lang=js"
export * from "./BuscaGlobal.vue?vue&type=script&lang=js"
import style0 from "./BuscaGlobal.vue?vue&type=style&index=0&id=7e2236da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2236da",
  null
  
)

export default component.exports